import { useCallback, useRef } from 'react'

/**
 * A hook that returns a function that generates unique numbers.
 * The returned function is memoized and will never re-initialize
 *
 * NOTE: At runtime, numbers returned from the same `useGetUniqueNumberGenerator` instance should always be unique (because JavaScript is single-threaded);
 * different `useGetUniqueNumberGenerator` may return the same number if one instance is used in web-workers.
 * NOTE: This is not cryptographically secure and should only be used for unique IDs or `generation` numbers.
 */
export function useGetUniqueNumberGenerator() {
  const counter = useRef(0)
  return useCallback(() => {
    const now = Date.now() // milliseconds since epoch
    counter.current = (counter.current + 1) % 1000 // prevent overflow
    return Number(`${now}${counter.current}`.padStart(3, '0'))
  }, [])
}
